
/*=========================================================================================
  File Name: actions.js
  Namespace: quizzes
  Description: Vuex Store - Quiz actions
==========================================================================================*/
import {
  uploadFile,
  partialEditFile,
  reUploadFile,
  listFiles
} from '@/services/files.services'

const actions = {
  async uploadAFile(context, formData) {
    const response = await uploadFile({
      file: formData
    })
    return response
  },
  async changeFileName(context, payload) {
    const response = await partialEditFile({
      payload: {
        name: payload.name
      },
      file: payload.file
    })
    return response
  },
  async changeFileUrl(context, payload) {
    const response = await partialEditFile({
      payload: {
        url: payload.url
      },
      file: payload.file
    })
    return response
  },
  async reUploadAFile(context, {formData, fileId}) {
    const response = await reUploadFile({
      file: formData,
      fileId
    })
    return response
  },
  async getAllFiles(context, files) {
    const response = await listFiles(files)
    return response
  },
}

export default actions